import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');

var userDataExon = localStorage.getItem("userDataExon") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon")))) : "";
var serviceName = "yonetim";
var crypto = require('crypto');
var yoneticiService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/enkucuk/",

    girisYap(kullaniciAdi, sifre) {
        var param = {
            data: {
                kullaniciAdi: kullaniciAdi,
                sifre: crypto.createHash('md5').update(sifre).digest("hex"),
                methodName: "login"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    sifremiUnuttum(kullaniciAdi, tcNo) {
        var param = {
            data: {
                kullaniciAdi: kullaniciAdi,
                tcNo: tcNo,
                methodName: "sifremiUnuttum"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    sifreGuncelle(eskiSifre, yeniSifre) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                yoneticiId: userDataExon["yonetimId"],
                eskiSifre: crypto.createHash('md5').update(eskiSifre).digest("hex"),
                yeniSifre: crypto.createHash('md5').update(yeniSifre).digest("hex"),
                methodName: "sifremiGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    yoneticiTanimlama(tur, tcNo, image, kullaniciAdi, sifre, adSoyad, gorev, eposta, cepTelefon, sabitTelefon, dahili) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                tur: tur, // 2: tam yetkili, 3:sınırlı yetki
                tcNo: tcNo,
                image: image,
                kullaniciAdi: kullaniciAdi,
                sifre: crypto.createHash('md5').update(sifre).digest("hex"),
                adSoyad: adSoyad,
                gorev: gorev,
                eposta: eposta,
                cepTelefon: cepTelefon,
                sabitTelefon: sabitTelefon,
                dahili: dahili,
                methodName: "yoneticiTanimlama"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    yoneticiList() {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                methodName: "yonetimListesi"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    yoneticiDetay(yetkiliKodu) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                yetkiliKodu: yetkiliKodu,
                firmaKodu: userDataExon["firmaKodu"],
                methodName: "yonetimDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    yoneticiDurumGuncelle(yetkiliKodu, durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                yetkiliKodu: yetkiliKodu,
                durum: durum,
                methodName: "yonetimDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    yoneticiGuncelle(yetkiliKodu, updateList) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                yetkiliKodu: yetkiliKodu,
                updateList: updateList,
                methodName: "yonetimGuncelle"
            }
        }
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yetkiList() {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                methodName: "yetkiList"
            }
        }
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    yetkiAtama(yetkiliKodu, yetkiKodu,durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                yetkiliKodu:yetkiliKodu,
                yetkiKodu:yetkiKodu,
                durum:durum,
                methodName: "yetkiAtama"
            }
        }
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default yoneticiService



